import { ShoppingCart } from '@phosphor-icons/react';

export const BookingSummaryCards = ({ totalQuantity, pendingCount, confirmedCount }) => (
  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
    <div className="bg-white border border-gray-200 p-4 rounded-lg flex items-center justify-between" data-testid="bookings-quantity-summary">
      <div>
        <p className="text-xs text-gray-500">Total Cylinders</p>
        <p className="text-2xl font-bold text-gray-900">{totalQuantity}</p>
      </div>
      <ShoppingCart size={28} className="text-gray-400" />
    </div>
    <div className="bg-white border border-amber-200 p-4 rounded-lg" data-testid="bookings-pending-count">
      <p className="text-xs text-amber-600">Pending</p>
      <p className="text-2xl font-bold text-amber-600">{pendingCount}</p>
    </div>
    <div className="bg-white border border-green-200 p-4 rounded-lg" data-testid="bookings-confirmed-count">
      <p className="text-xs text-green-600">Confirmed</p>
      <p className="text-2xl font-bold text-green-600">{confirmedCount}</p>
    </div>
  </div>
);
